import cssifyObject from 'css-in-js-utils/lib/cssifyObject';

import arrayReduce from './arrayReduce';
import objectReduce from './objectReduce';

export default function cssifyKeyframe(frames, animationName) {
  var prefixes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [''];

  var keyframe = objectReduce(frames, function (css, frame, percentage) {
    return '' + css + percentage + '{' + cssifyObject(frame) + '}';
  }, '');

  return arrayReduce(prefixes, function (cssKeyframe, prefix) {
    return cssKeyframe + '@' + prefix + 'keyframes ' + animationName + '{' + keyframe + '}';
  }, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/cssifyKeyframe.js
// module id = 716
// module chunks = 0